// extracted by mini-css-extract-plugin
export var collapsedSummary = "_r4-0";